import { suggestNames } from '../shell/suggest';

const sheetModules = import.meta.glob('../../content/cheatsheets/*.md', {
  eager: true,
  query: '?raw',
  import: 'default',
}) as Record<string, string>;

export interface CheatSheet {
  id: string;
  title: string;
  content: string;
}

function firstTitle(content: string, fallback: string): string {
  const firstLine = content.split('\n', 1)[0] ?? '';
  return firstLine.startsWith('# ') ? firstLine.slice(2).trim() : fallback;
}

/** Fiches mémo embarquées (Markdown), triées par identifiant. */
export const CHEATSHEETS: readonly CheatSheet[] = Object.entries(sheetModules)
  .map(([path, content]) => {
    const id = path.split('/').pop()?.replace(/\.md$/, '') ?? path;
    return { id, title: firstTitle(content, id), content };
  })
  .sort((left, right) => left.id.localeCompare(right.id));

export function findCheatSheet(id: string): CheatSheet | null {
  const wanted = id.trim().toLowerCase();
  return (
    CHEATSHEETS.find((sheet) => sheet.id === wanted) ??
    CHEATSHEETS.find((sheet) => sheet.title.toLowerCase().includes(wanted)) ??
    null
  );
}

export function suggestCheatSheets(query: string): string[] {
  return suggestNames(
    query,
    CHEATSHEETS.map((sheet) => sheet.id),
  );
}

/** Toutes les fiches concaténées, prêtes à télécharger. */
export function allCheatSheetsMarkdown(): string {
  return `${CHEATSHEETS.map((sheet) => sheet.content.trimEnd()).join('\n\n---\n\n')}\n`;
}
